module.exports = __webpack_public_path__ + "img/GAME_NUMBER.24b745fd.png";